import { defineStore } from "pinia";
import { LocalStorageConst } from "~~/consts/LocalStorage";
import UserModel from "~~/models/UserModel";

export const useUserStore = defineStore({
  id: "user-store",
  state: () => {
    return {
      userIsLoggedIn: false,
      userInformation: null as unknown as Ref<UserModel>,
      jwtToken: null,
    };
  },
  actions: {
    async isLoggedIn() {
      const { data: isLoggedIn } = await useAsyncData("isLogged", async () => {
        return $fetch(useBaseUrl() + `/api/Authentication/IsLogged`, {
          headers: await useUser().getHeadersWithToken(),
        });
      });

      this.userIsLoggedIn = isLoggedIn?.value ? true : false;
    },
    async loadUserInformation() {
      const { data } = await useAsyncData<UserModel>("userInfo", async () =>
        $fetch(useBaseUrl() + `/api/Authentication/GetCurrentUser`, {
          headers: await useUser().getHeadersWithToken(),
        })
      );
      this.userInformation = data.value;
    },
    async requestForNewToken(email: string, captchaToken: string) {
      const { data, error } = await useFetch<any>(
        useBaseUrl() + `/api/Authentication/GenerateAccessToken`,
        {
          headers: useRequestHeaders(),
          method: "POST",
          body: JSON.stringify({
            email: email,
            captchaToken: captchaToken,
          }),
          initialCache: false,
        }
      );

      if (error && error.value && error.value.response) {
        let errorMessage = error.value.response._data?.errorCode;
        if (
          error.value.response._data?.errors &&
          error.value.response._data?.errors.length > 0
        ) {
          const err = error.value.response._data?.errors[0];
          errorMessage = err.propertyName;
        }
        throw new Error(errorMessage);
      }

      localStorage.removeItem(LocalStorageConst.TOKEN);
      localStorage.removeItem(LocalStorageConst.CURRENT_PROSPECT_ID);
    },
    async requestForJWTToken(accessTokenKey: string) {
      let { data } = await useFetch<any>(
        useBaseUrl() + `/api/Authentication/Authenticate`,
        {
          headers: useRequestHeaders(),
          method: "POST",
          body: JSON.stringify({
            accessTokenKey: accessTokenKey,
          }),
          initialCache: false,
        }
      );
      this.jwtToken = data.value;

      localStorage.removeItem(LocalStorageConst.TOKEN);
      localStorage.removeItem(LocalStorageConst.CURRENT_PROSPECT_ID);
    },
    async logout() {
      this.userInformation = null;
      this.jwtToken = null;
      localStorage.removeItem(LocalStorageConst.TOKEN);
      localStorage.removeItem(LocalStorageConst.CURRENT_PROSPECT_ID);
      await navigateTo(useLocalePath()("/login") + "/");
    },
  },
  getters: {
    getUserIsLoggedIn: (state) => state.userIsLoggedIn,
    getUserInformation: (state) => state.userInformation,
    getJwtToken: (state) => state.jwtToken,
  },
});
